// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .card-title {
    color: #004481;
    text-align: left;
    margin-left: 240px; 
  }
  
  .sup-form-container {
    padding: 20px;
    text-align: center; 
  }
  
  .form-section {
    border: 1px solid  #4e6264;
    border-radius: 15px;
    width: 100%;
    max-width: 1115px;
    background-color: #F8FAFC;
    margin-bottom: 20px;
    padding: 20px;
    margin-left: auto; 
    margin-right: auto;
    position: relative; 
  }
  
  .button {
    text-align: right; 
    margin-top: 20px;
    margin-right: 250px;
    color: green;
    border-color: green;
    
  }
  .submit {
    color: rgba(1,77,78,0.3); 
    border-color: rgba(1,77,78,0.3);
    margin-Left: 1000px;
  }
  .contact-detail-card, .supplier-id-card {
    border: 1px solid #CECECE;
    border-radius: 15px;
    background-color: #F8FAFC;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; 
  }
  
  .form-item-left-align .ant-form-item-label {
    text-align: left;
    margin-bottom: 8px; 
  }
  
  .form-item-left-align .ant-form-item-control-input {
    text-align: left;
  }
  
  
  .contact-detail-fields, .supplier-id-fields {
    flex: 1;
    margin-left: auto; 
    margin-right: auto;
  }
  
  .remove-button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; 
  }
  
  .add-button-container {
    text-align: center; 
    margin-top: 20px;
  }
  

  /* Align titles to the left */
.card-title {
  color: #004481;
  text-align: left;
  margin-left: 240px; /* Add some space below the title */
}

/* Form container */
.sup-form-container {
  padding: 20px;
  text-align: center; /* Center align the contents within the container */
}

/* Form section style */
.form-section {
  border: 1px solid  #4e6264;
  border-radius: 15px;
  width: 100%;
  max-width: 1115px;
  background-color: #F8FAFC;
  margin-bottom: 20px;
  padding: 20px;
  margin-left: auto; /* Center the form section */
  margin-right: auto;
  position: relative; /* To use absolute positioning inside */
}

/* Submit button to the right */
.button {
  text-align: right; /* Aligns the button to the right */
  margin-top: 20px;
  margin-right: 250px;
  
}

.contact-detail-card, .supplier-id-card {
  border: 1px solid #CECECE;
  border-radius: 15px;
  background-color: #F8FAFC;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; /* Center the items within the card */
}

.form-item-left-align .ant-form-item-label {
  text-align: left;
  margin-bottom: 8px; /* Adjust as needed */
}

.form-item-left-align .ant-form-item-control-input {
  text-align: left;
}

/* supform.css */

/* Left-align validation messages */
.ant-form-item-explain {
  text-align: left;
  color: red; /* Optional: if you want to ensure the color is red */
}

.ant-form-item-explain-error {
  text-align: left;
  color: red; /* Optional: if you want to ensure the color is red */
}



.contact-detail-fields, .supplier-id-fields {
  flex: 1;
  margin-left: auto; /* Center the fields */
  margin-right: auto;
}

.remove-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; /* Center the remove button */
}

.add-button-container {
  text-align: center; /* Center the add button */
  margin-top: 20px;
}

.ant-select-selector{
  text-align: start;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Supplier/SupplierForm.css"],"names":[],"mappings":";EACE;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;;EAErB;EACA;IACE,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,OAAO;IACP,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;;EAGA,6BAA6B;AAC/B;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB,EAAE,mDAAmD;AACzE;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB,EAAE,4BAA4B;EAC/C,kBAAkB;EAClB,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB,EAAE,mCAAmC;EACtD,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA;EACE,gBAAgB;EAChB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB,mCAAmC;AACnC;EACE,gBAAgB;EAChB,UAAU,EAAE,qDAAqD;AACnE;;AAEA;EACE,gBAAgB;EAChB,UAAU,EAAE,qDAAqD;AACnE;;;;AAIA;EACE,OAAO;EACP,iBAAiB,EAAE,sBAAsB;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA;EACE,kBAAkB,EAAE,0BAA0B;EAC9C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["\n  .card-title {\n    color: #004481;\n    text-align: left;\n    margin-left: 240px; \n  }\n  \n  .sup-form-container {\n    padding: 20px;\n    text-align: center; \n  }\n  \n  .form-section {\n    border: 1px solid  #4e6264;\n    border-radius: 15px;\n    width: 100%;\n    max-width: 1115px;\n    background-color: #F8FAFC;\n    margin-bottom: 20px;\n    padding: 20px;\n    margin-left: auto; \n    margin-right: auto;\n    position: relative; \n  }\n  \n  .button {\n    text-align: right; \n    margin-top: 20px;\n    margin-right: 250px;\n    color: green;\n    border-color: green;\n    \n  }\n  .submit {\n    color: rgba(1,77,78,0.3); \n    border-color: rgba(1,77,78,0.3);\n    margin-Left: 1000px;\n  }\n  .contact-detail-card, .supplier-id-card {\n    border: 1px solid #CECECE;\n    border-radius: 15px;\n    background-color: #F8FAFC;\n    padding: 20px;\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center; \n  }\n  \n  .form-item-left-align .ant-form-item-label {\n    text-align: left;\n    margin-bottom: 8px; \n  }\n  \n  .form-item-left-align .ant-form-item-control-input {\n    text-align: left;\n  }\n  \n  \n  .contact-detail-fields, .supplier-id-fields {\n    flex: 1;\n    margin-left: auto; \n    margin-right: auto;\n  }\n  \n  .remove-button-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center; \n  }\n  \n  .add-button-container {\n    text-align: center; \n    margin-top: 20px;\n  }\n  \n\n  /* Align titles to the left */\n.card-title {\n  color: #004481;\n  text-align: left;\n  margin-left: 240px; /* Add some space below the title */\n}\n\n/* Form container */\n.sup-form-container {\n  padding: 20px;\n  text-align: center; /* Center align the contents within the container */\n}\n\n/* Form section style */\n.form-section {\n  border: 1px solid  #4e6264;\n  border-radius: 15px;\n  width: 100%;\n  max-width: 1115px;\n  background-color: #F8FAFC;\n  margin-bottom: 20px;\n  padding: 20px;\n  margin-left: auto; /* Center the form section */\n  margin-right: auto;\n  position: relative; /* To use absolute positioning inside */\n}\n\n/* Submit button to the right */\n.button {\n  text-align: right; /* Aligns the button to the right */\n  margin-top: 20px;\n  margin-right: 250px;\n  \n}\n\n.contact-detail-card, .supplier-id-card {\n  border: 1px solid #CECECE;\n  border-radius: 15px;\n  background-color: #F8FAFC;\n  padding: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center; /* Center the items within the card */\n}\n\n.form-item-left-align .ant-form-item-label {\n  text-align: left;\n  margin-bottom: 8px; /* Adjust as needed */\n}\n\n.form-item-left-align .ant-form-item-control-input {\n  text-align: left;\n}\n\n/* supform.css */\n\n/* Left-align validation messages */\n.ant-form-item-explain {\n  text-align: left;\n  color: red; /* Optional: if you want to ensure the color is red */\n}\n\n.ant-form-item-explain-error {\n  text-align: left;\n  color: red; /* Optional: if you want to ensure the color is red */\n}\n\n\n\n.contact-detail-fields, .supplier-id-fields {\n  flex: 1;\n  margin-left: auto; /* Center the fields */\n  margin-right: auto;\n}\n\n.remove-button-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center; /* Center the remove button */\n}\n\n.add-button-container {\n  text-align: center; /* Center the add button */\n  margin-top: 20px;\n}\n\n.ant-select-selector{\n  text-align: start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
